import React from 'react';
import { Info, AlertTriangle, XCircle, CheckCircle } from '../../icons';
import { cn } from '../ui/cn';

const TYPE_STYLES = {
  info: { wrap: 'border-info/40', icon: 'bg-info-soft text-info', Icon: Info },
  warning: { wrap: 'border-amber/40', icon: 'bg-amber-soft text-amber', Icon: AlertTriangle },
  error: { wrap: 'border-danger/40', icon: 'bg-danger-soft text-danger', Icon: XCircle },
  success: { wrap: 'border-accent/40', icon: 'bg-accent-soft text-accent', Icon: CheckCircle },
};

const InfoBanner = ({ settings }) => {
  // Backwards compatibility - use defaults if no settings provided
  const visible = settings?.visible ?? true;
  const title = settings?.title ?? 'Data Collection Note:';
  const message =
    settings?.message ??
    'Fetching data from Bazaraki URLs (both individual items and searches) may be blocked by browser security (CORS). If so, input data manually. A backend proxy is needed for reliable automated fetching. Always respect website Terms of Service.';
  const type = settings?.type ?? 'warning';

  if (!visible) return null;

  const style = TYPE_STYLES[type] || TYPE_STYLES.warning;
  const { Icon } = style;

  return (
    <div className={cn('mb-4 lg:mb-6 p-3.5 bg-card border rounded-card flex items-start gap-3', style.wrap)}>
      <span className={cn('w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0', style.icon)}>
        <Icon className="w-5 h-5" />
      </span>
      <div className="min-w-0">
        <h3 className="font-semibold text-primary text-sm">{title}</h3>
        <p className="text-sm text-secondary mt-0.5">{message}</p>
      </div>
    </div>
  );
};

export default InfoBanner;
